<div class="modal-header">
  <h4 class="modal-title">{{'manageAccessories.title' | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <table class="table table-hover table-striped number-mapping-table fixed-layout" fixedHeader>
      <thead>
        <tr class="d-flex col-12 p-0">
          <th class="d-flex col-10">
            <div class="col-4">{{'manageAccessories.articleId' | translate}}</div>
            <div class="col-4">{{'manageAccessories.articleNumber' | translate}}</div>
            <div class="col-4">{{'manageAccessories.rotationDelta' | translate}}</div>
          </th>
          <th class="col-2 dots">
            <span class="dropdown" dropdown #dropdown="bs-dropdown">
              <a data-toggle="dropdown" dropdownToggle (click)="false"><i class="mdi mdi-dots-vertical c-pointer"></i></a>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                <li *ngFor="let menuItem of getHeaderMenu()">
                  <a class="dropdown-item" (click)="menuItem.action()">
                    <app-svg-icon [type]="menuItem.icon" size="medium-small"/>
                   <span [innerHTML]="menuItem.label | translate"></span>
                 </a>
               </li>
              </ul>
            </span>
          </th>
        </tr>
      </thead>
    </table>
      <div class="overflow-xh" style="min-height: 180px">
        <ng-scrollbar #scroll [visibility]="'hover'">
            <table class="table table-hover table-striped number-mapping-table mb-0">
              <tbody minRowCount [update]="update">
                <tr class="d-flex col-12 p-0" *ngFor="let accessory of accessoriesList; let ind = index">
                  <td class="d-flex col-10">
                    <div class="col-4">{{accessory.accessoryArticleId}}</div>
                    <div class="col-4">{{accessory.accessoryArticleNumber}}</div>
                    <div class="col-4">{{accessory.rotationDelta}}</div>
                  </td>
                  <td class="col-2 dots">
                   <span class="dropdown" [dropup]="ind === accessoriesList.length - 1 && accessoriesList.length > 1" dropdown #dropdown="bs-dropdown">
                     <a data-toggle="dropdown" dropdownToggle (click)="false"><i class="mdi mdi-dots-vertical c-pointer"></i></a>
                     <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                      <li *ngFor="let menuItem of getAccessoryMenu(accessory)">
                         <a class="dropdown-item" (click)="menuItem.action(accessory)">
                           <app-svg-icon [type]="menuItem.icon" size="medium-small"/>
                          <span [innerHTML]="menuItem.label | translate"></span>
                        </a>
                      </li>
                     </ul>
                   </span>
                 </td>
                </tr>
              </tbody>
            </table>
        </ng-scrollbar>
      </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">
    {{ 'global.label.cancel' | translate }}
  </button>
  <button type="submit" class="btn btn-primary" (click)="save()">
    {{ 'global.label.save' | translate }}
  </button>
</div>
